import React from 'react';
import {Container, Row, Col, Figure} from 'react-bootstrap';
import './Home.css';

const  Mining = () => {
    return ( 
        <Container>
        <Row>
          <Col xs={12} md={12}>
          <Figure className="itemsimg">
          <Figure.Caption>
        <p><h2><span className="fontcolor">MINING DIVISION & PLANT HIRE</span></h2></p>
            <p><h4>BUK has expanded their products and services to include plant hire and stone crushing services
for mining and quarry purposes.
We can also setup the stone crushing plant and its support machinery in designated mines and companies
for stone crushing purposes on agreed terms. This will ably crush stones into different sizes 0mm - 100mm
for building, construction, railway lines, dams, and mining while quarry dust an be used for making concrete blocks</h4></p>
        </Figure.Caption>
        <Figure.Image
          width={850}
          height={850}
          alt="171x180"
          src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596766/nonedb/mining_plant_hire_hmiit7.jpg"
        />
        
      </Figure>  
        
          </Col>
        </Row>
        
      </Container>
     );
};
 
export default Mining;